import { defaultState } from "./state";
import leaveActionTypes from "./action-types";
import commonTypes from "../common/action-types";
const types = { ...commonTypes, ...leaveActionTypes };

// voting behavior reducer
const voteBehaviors = (
  voteBehaviorsState = defaultState.behaviors,
  action
) => {
  switch (action.type) {
    case types.SET_VOTE_BEHAVIORS:
      return action.data;

    case types.CLEAN_STATE:
      return defaultState.behaviors;

    default:
      return voteBehaviorsState;
  }
};

// voting rating reducer
const voteRatings = (
  voteRatingsState = defaultState.ratings,
  action
) => {
  switch (action.type) {
    case types.SET_VOTE_RATINGS:
      return action.data;

    case types.CLEAN_STATE:
      return defaultState.ratings;

    default:
      return voteRatingsState;
  }
};

// my votes reducer
const myVotes = (
  myVotesState = defaultState.myVotes,
  action
) => {
  switch (action.type) {
    case types.SET_MY_VOTES:
      return action.data;

    case types.CLEAN_STATE:
      return defaultState.myVotes;

    default:
      return myVotesState;
  }
};


export default {
  voteBehaviors,
  voteRatings,
  myVotes,
};
